import { Badge, Button, Collapse, Container, Divider, Grid, IconButton, makeStyles, TextField, Tooltip, Typography, withStyles } from '@material-ui/core'
import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchSystemMetrics, giveReturnsTestResult } from '../../actions';
import InfoIcon from '@material-ui/icons/Info';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import ArrowForwardIosRoundedIcon from '@material-ui/icons/ArrowForwardIosRounded';


const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        margin: "10px"
    }, root: {
        textAlign: 'center'
    }, currentProf: {
        margin: '10px 0px'
    },
    instructions: {
        margin: '10px 0px 0px',
        color: '#aee3e8'
    },
    examples: {
        marginTop: '30px',
        marginBottom: '40px',
        fontSize: "smaller"
    },
    textField: {
        margin: "10px 0px 10px",
        width: "100%"
    },

    definitionButton: {
        margin: "10px 0px 20px"
    },
    definitionText: {
        margin: "0px 0px 10px"
    },
    exampleText: {
        margin: "10px 0px 10px",
    },
    box: {
        border: "3px solid #c4c4c4",
        marginTop: "25px",
        padding: "20px 10px",
        marginBottom: "25px",
        textAlign: "center"
    },
    dividerThicker: {
        margin: "10px 0px 10px"
    }, closeRow: {
        background: theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
        padding: '20px 0px',
        textAlign: 'center'
    }, rightWrongButtons: {
        margin: "20px 0px 20px"
    }, highlight: {
        color: '#ffffff'
    }, statUpdate: {
        textAlign: 'center',
        margin: '10px 0px 20px'
    }, infoIcon: {
        margin: '10px 0px 0px'
    }



}));

const capitalize = (word) => {
    if (typeof word !== 'string') return null;
    return word[0].toUpperCase() + word.slice(1);

}

const BlueOnGreenTooltip = withStyles({
    tooltip: {
        color: "black",
        backgroundColor: "white"
    }
})(Tooltip);

const ReturnsTestDialog = ({ wordData = [], totalLength = 0 }) => {


    const classes = useStyles();
    const dispatch = useDispatch();
    const [openDefinition, setOpenDefinition] = useState(false);
    const [openExamples, setOpenExamples] = useState(false);
    const [TextFieldValue, setTextFieldValue] = useState('');
    const systemMetrics = useSelector(state => state.systemMetrics);
    const audioFile = useRef(null);
    const [exampleNumb, setExampleNumb] = React.useState(0);

    if (systemMetrics === null) {
        dispatch(fetchSystemMetrics());
    }
    const incrementExampleNumb = (word) => {
        if (exampleNumb === word.examples.length - 1) return;
        setExampleNumb(exampleNumb + 1);
    }

    const decrementExampleNumb = () => {
        if (exampleNumb === 0) return;
        setExampleNumb(exampleNumb - 1);
    }
    const resetExampleNumbCount = () => {
        setExampleNumb(0);
    }




    return (
        <>
            <Grid className={classes.closeRow} container justify="center" >
                <Grid item sm={12}>
                    <Typography variant='h3'>
                        <Badge anchorOrigin={{ horizontal: 'right', vertical: 'top' }} badgeContent={totalLength} color="primary">
                            {capitalize(wordData?.word?.word)}
                        </Badge>
                    </Typography>
                    <Typography variant="subtitle2">
                        {wordData?.word?.partOFSpeech}
                    </Typography>

                </Grid>
                <Grid item>
                    <Typography color='textSecondary' variant='caption'> Returns must be completed to return to the dashboard.</Typography>
                </Grid>
            </Grid>

            <Container className={classes.root}>
                <Typography className={classes.currentProf}>
                    Current Proficiency: {wordData.proficiency}
                </Typography>

                <Grid container justify='center' alignItems='flex-start'>

                    <Grid item>
                        <BlueOnGreenTooltip enterTouchDelay={50} className={classes.infoIcon} title={<Typography variant='caption'>Type in your guess for the definition.<br /><br /> Click on 'Show Definition' to continue to the next step.</Typography>}>
                            <InfoIcon />
                        </BlueOnGreenTooltip>
                    </Grid>
                    <Grid>
                        <IconButton color='primary' onClick={(event) => { event.stopPropagation(); audioFile.current.play(); }}>

                            <VolumeUpIcon />

                        </IconButton>
                    </Grid>
                </Grid>


                <TextField value={TextFieldValue} onChange={(e) => setTextFieldValue(e.target.value)} className={classes.textField}
                    id="type-in-guess-here"
                    label={<span> define <span className={classes.highlight}>{capitalize(wordData?.word?.word)}</span> here</span>}
                    multiline variant='outlined' rows={5} >
                </TextField>

                <Grid container justify='center'>
                    <Grid item>
                        <Button className={classes.definitionButton} onClick={() => setOpenDefinition(!openDefinition)} variant="outlined">{openDefinition ? "Hide Definition" : "Show Definition"} </Button>
                    </Grid>

                </Grid >

                <Collapse in={openDefinition} timeout="auto" unmountOnExit>
                    <Grid container justify='center'>
                        <Grid item>
                            <Typography className={classes.definitionText} variant="body2" >
                                {wordData?.word?.definition}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Divider className={classes.dividerThicker} />
                    <Grid container justify='center'>
                        <Grid item>
                            <Grid container justify='center'>
                                <Grid item>
                                    <Button className={classes.definitionButton} onClick={() => setOpenExamples(!openExamples)} variant="outlined">{openExamples ? "Hide Examples" : "Show Examples"} </Button>
                                </Grid>
                            </Grid >
                            <Collapse in={openExamples} timeout="auto" unmountOnExit>
                                <Grid container justify='space-around' alignItems='center'>



                                    <Grid item sm={12}>
                                        <Typography className={classes.examples} variant="body2">
                                            {wordData.word?.examples?.length === 0 ? "This word has no examples, Soooorry." : wordData?.word?.examples[exampleNumb]}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={2}>
                                        <IconButton onClick={decrementExampleNumb} disabled={exampleNumb === 0 ? true : false}>
                                            <ArrowBackIosRoundedIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item sm={2}>
                                        <IconButton onClick={() => incrementExampleNumb(wordData?.word)} disabled={wordData?.word?.examples?.length - 1 === exampleNumb ? true : false}>
                                            <ArrowForwardIosRoundedIcon />
                                        </IconButton>
                                    </Grid>

                                </Grid>
                            </Collapse>
                        </Grid>
                    </Grid>

                    <Divider className={classes.dividerThicker} />

                    <Grid container justify='center' alignItems='flex-start'>

                        <Grid item>
                            <BlueOnGreenTooltip enterTouchDelay={50} className={classes.infoIcon} title={<Typography variant='caption'>Compare your definition you wrote out with the definition given.<br /><br /> If you believe you know this word, click 'Correct'. Your proficiency will go up, you'll earn some money, and you'll see the word at a later date corresponding with proficiency. <br /><br /> If you think you don't know the word yet, then click 'Incorrect'. You'll only pay a small fee if the word in not in your word bank. But don't worry we want you to learn this word, you'll see this word tomorrow. <br /> <br /> Check out the About page for more information.</Typography>}>
                                <InfoIcon />
                            </BlueOnGreenTooltip>
                        </Grid>
                    </Grid>

                    <Grid container justify='space-evenly' >

                        <Grid item >
                            <Button onClick={() => { setOpenExamples(false); resetExampleNumbCount(); setOpenDefinition(false); setTextFieldValue(''); dispatch(giveReturnsTestResult(wordData?.word?.word, false)) }} className={classes.rightWrongButtons} variant='contained' color='secondary' >Incorrect</Button>
                        </Grid>

                        <Grid item>

                            <Button onClick={() => { setOpenExamples(false); resetExampleNumbCount(); setOpenDefinition(false); setTextFieldValue(''); dispatch(giveReturnsTestResult(wordData?.word?.word, true)) }} className={classes.rightWrongButtons} variant='contained' color='primary'>Correct</Button>
                        </Grid>

                    </Grid>





                </Collapse>

                <audio ref={audioFile} src={wordData?.word?.audioURL} > </audio>


            </Container >
        </>
    )
}



export default ReturnsTestDialog
